module.exports = __webpack_public_path__ + "static/img/clause_letter111.cc9e8d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/book/clause_letter111.png
// module id = tLQy
// module chunks = 1